import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    backgroundColor: tokens.colorNeutralBackground1,
    width: "100%",
    ...shorthands.padding("24px", "18px", "28px", "18px"),
    "@media (min-width: 500px)": {
      paddingTop: "24px",
    },
    "@media (min-width: 500px) and (max-width: 899px)": {
      backgroundColor: "unset",
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      backgroundColor: "unset",
    },
    "@media (min-width: 1240px) ": {
      backgroundColor: "unset",
    },
  },
  title: {
    width: "100%",
    alignItems: "center",
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.padding("0px", "0px", "12px", "0px"),
  },
  info: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  infoTitle: {
    color: tokens.colorNeutralForeground1,
  },
  infoSubtitle: {
    fontWeight: tokens.fontWeightRegular,
  },
});
